import { all, call, put, takeEvery } from 'redux-saga/effects'
import { setAllRequestTypeList, setAssignedToList, setBuyerNameList, setCostCenterList, setFleetProcessorList, setIsDropDownsLoading, setRegionList, setRequestedByList, setStatusList, setUpdatedByList } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';
import { GET_ALL_REQUEST_TYPE_LIST, GET_ASSIGNED_TO_LIST, GET_BUYER_NAME_LIST, GET_COST_CENTER_LIST, GET_FLEET_PROCESSORS, GET_REGION_LIST, GET_REQUESTED_BY_LIST, GET_STATUS_LIST, GET_UPDATED_BY_LIST } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsType';
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getAllRequestTypeList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint : `orders/grid/home/dropdown/requesttype`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setAllRequestTypeList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setAllRequestTypeList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getStatusList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint : `orders/grid/dropdown/status`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setStatusList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setStatusList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getRegionList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint :`orders/grid/dropdown/region`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setRegionList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setRegionList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getCostCenterList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint : `orders/grid/dropdown/costcenter`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setCostCenterList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setCostCenterList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getRequestedByList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint :  `orders/grid/dropdown/requestor`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setRequestedByList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setRequestedByList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getAssignedToList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint : `orders/grid/dropdown/assignedTo`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setAssignedToList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setAssignedToList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getUpdatedByList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.OrderManagement,    
            endpoint : `orders/grid/dropdown/updatedBy`,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setUpdatedByList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setUpdatedByList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getBuyerNameList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `orders/grid/dropdown/buyername`,
            payload: null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setBuyerNameList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setBuyerNameList([]))
        yield put(setIsDropDownsLoading(false))
    }
}
function* getFleetProcessorsList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload = {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/dropdown/fleetprocessor`,
            apiMethod :  apiMethod.GET,
            payload : null
            
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setFleetProcessorList(response));
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setFleetProcessorList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* watchGetRequestType() {
    yield takeEvery(GET_ALL_REQUEST_TYPE_LIST, getAllRequestTypeList)
    yield takeEvery(GET_STATUS_LIST, getStatusList)
    yield takeEvery(GET_REGION_LIST, getRegionList)
    yield takeEvery(GET_COST_CENTER_LIST, getCostCenterList)
    yield takeEvery(GET_REQUESTED_BY_LIST, getRequestedByList)
    yield takeEvery(GET_ASSIGNED_TO_LIST, getAssignedToList)
    yield takeEvery(GET_UPDATED_BY_LIST, getUpdatedByList)
    yield takeEvery(GET_BUYER_NAME_LIST, getBuyerNameList)
    yield takeEvery(GET_FLEET_PROCESSORS, getFleetProcessorsList)
}

export default function* combinedSaga() {
    yield all([
        watchGetRequestType()
    ])
}